var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NavBar'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v("404: Not found")])])
}]

export { render, staticRenderFns }